import { render, staticRenderFns } from "./FourEcosystems.vue?vue&type=template&id=3fdb6d34&scoped=true"
import script from "./FourEcosystems.vue?vue&type=script&lang=js"
export * from "./FourEcosystems.vue?vue&type=script&lang=js"
import style0 from "./FourEcosystems.vue?vue&type=style&index=0&id=3fdb6d34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdb6d34",
  null
  
)

export default component.exports